import { flow, getParent, types } from 'mobx-state-tree';
// import { when } from 'mobx';
import Video from './Video';

const URL = 'education-center/v1';

const Playlist = types.model('playlist',{
  loaded: types.optional(types.boolean, false),
  sectionId: types.optional(types.string, ''),
  id: types.identifier(),
  title: types.optional(types.string, ''),
  subtitle: types.maybe(types.string, ''),
  description: types.maybe(types.string, ''),
  displayIndex: types.optional(types.number, 0),
  deleted: types.optional(types.boolean, false),
  videos: types.optional(types.array(Video), []),
  searchResultParentIndex: types.maybe(types.number),
}).views(self => ({
  get transport5007() {
    return getParent(self,4).transport5007;
  },
  get filteredVideos() {
    if(typeof self.searchResultParentIndex !== 'number') {
      return [];
    }
    return self.videos.filter(({videoId}) => {
      // look in the searchResults if there is any id equal with the current video's id
      return self.searchResults.find(foundVideoId => foundVideoId.videoId === videoId);
    });
  },
  get searchResults() {
    if(typeof self.searchResultParentIndex !== 'number') {
      return [];
    }
    return getParent(self,2).searchResults[self.searchResultParentIndex] ? getParent(self,2).searchResults[self.searchResultParentIndex].videos : [];
  }
})).actions(self=>({
  loadVideos(afterVideosLoaded = null) {
    if(!self.loaded) {
      self.fetchVideos(afterVideosLoaded);
    } else if(afterVideosLoaded !== null) {
      afterVideosLoaded();
    }
  },
  fetchVideos: flow(function* fetchVideos(afterVideosLoaded) {
    try {
      const { data } = yield self.transport5007.fetch(
        `${URL}/Playlists/${self.id}/videos`,
        {},
        {}
      );
      data.videos.forEach(elem => {
        if(self.videos.find(({videoId})=>videoId === elem.id)) {
          return;
        }
        const video = Video.create(Object.assign(
          {},
          elem,
          {id: `p_${self.id}_v_${elem.id}`},
          {videoId: elem.id}));
        self.videos.push(video);
        video.fetchWatchInfo();
      })
      if(afterVideosLoaded !== null) {
        afterVideosLoaded();
      }
      self.loaded = true;
    } catch (error) {
      console.error('Getting Videos failed: ', error);
    }
  }),
  setVideoResultsParentIndex(searchResultParentIndex) {
    self.searchResultParentIndex = searchResultParentIndex;
  }
}));

export default Playlist;
